var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaretRightBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.34995 17.45C9.21662 17.2833 9.14579 17.1 9.13745 16.9C9.12912 16.7 9.19995 16.525 9.34995 16.375L13.75 11.975L9.32495 7.54997C9.19162 7.41664 9.12912 7.23747 9.13745 7.01247C9.14579 6.78747 9.21662 6.60831 9.34995 6.47497C9.51662 6.30831 9.69579 6.22914 9.88745 6.23747C10.0791 6.24581 10.25 6.32497 10.4 6.47497L15.375 11.45C15.4583 11.5333 15.5166 11.6166 15.55 11.7C15.5833 11.7833 15.6 11.875 15.6 11.975C15.6 12.075 15.5833 12.1666 15.55 12.25C15.5166 12.3333 15.4583 12.4166 15.375 12.5L10.425 17.45C10.275 17.6 10.1 17.6708 9.89995 17.6625C9.69995 17.6541 9.51662 17.5833 9.34995 17.45Z",
    fill: "#5448C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretRightBlue);
export default __webpack_public_path__ + "static/media/caret-right-blue.0662fca59de018cd278245be6e010d15.svg";
export { ForwardRef as ReactComponent };